// extracted by mini-css-extract-plugin
export default {"tag":"StatusDropdown_tag__+qiI6","icon":"StatusDropdown_icon__RvaaL","nativeWrapper":"StatusDropdown_nativeWrapper__hx2+f","nativeSelect":"StatusDropdown_nativeSelect__f9LrW"};